module.exports = new __parcel__URL__("step_three_vector_light.d5a90ef9.png").toString();